import { useRouter } from "next/router"
import { Button } from "@components/anti/Button"
import { Card } from "@components/anti/Card"
import { translations } from "src/helper/translations"
import SectionNotFound from "../SectionNotFound"

export default function CardList({
  data,
  grid,
  render,
  hasMore,
  loading,
  showTotal,
  className,
  notFoundText,
  notFoundTitle,
  notFoundClassName = "",
  onClickLoadMore,
  keyPrefix = "card-list-item",
}) {
  const Router = useRouter()
  return (
    <div className={`card-list ${className}`}>
      {showTotal ? (
        <p className="card-list__total-data">
          {Router.locale === "en"
            ? translations.location_total_en(showTotal)
            : translations.location_total_id(showTotal)}
        </p>
      ) : null}
      <div className="row">
        {data?.length ? (
          data?.map((item, i) => (
            <div className={grid || "col-md-4"} key={`${keyPrefix}-${i}`}>
              {render(item, i)}
            </div>
          ))
        ) : (
          <SectionNotFound
            sectionName={`not-found-${keyPrefix} ${notFoundClassName}`}
            title={notFoundTitle}
            text={notFoundText}
          />
        )}
      </div>
      {hasMore ? (
        <div className="row row-btn justify-content-center mt-5">
          <Button
            variant="outline-primary"
            onClick={onClickLoadMore}
            className={loading ? "loading" : ""}
          >
            {Router.locale === "en" ? "Load More" : "Muat lebih banyak"}
          </Button>
        </div>
      ) : null}
    </div>
  )
}
